import { useEffect } from 'react';
import { useCart } from '../useCart';
import { tc } from '../../lib/trackingContext';
import { deferUntilNewTitle } from '../../lib/deferUntilNewTitle';

export const useCheckoutStartTracking = () => {
  const { cart, loaded: cartLoaded } = useCart();

  useEffect(() => {
    if (cartLoaded) {
      deferUntilNewTitle(() => {
        tc.track('Checkout Started', {
          addToScopeOnce: {
            cart,
            products: cart.attributes.cartItems.map(item => item.data)
          }
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartLoaded]);
};
